import React, { createContext } from "react";

export const initialData = {
  business: {},
  menuList: {},
};

export const QrMenuContext = createContext(initialData);
